export default "__VITE_ASSET__0020f940__"